import Connector, { takeQuery } from '../../agent';
import types from './types';

const AccessRequests = {
  newAccessRequest: ({ accessRequestDto }) =>
    Connector.api.post('/accessRequests/new', accessRequestDto),
  getInitialData: () => Connector.api.get(`/accessRequests/getInitialData`)
};

const accessRequestSagas = [
  takeQuery(types.NEW_ACCESS_REQUEST, AccessRequests.newAccessRequest),
  takeQuery(types.GET_ACCESS_REQUEST_INITIAL_DATA, AccessRequests.getInitialData)
];

export default accessRequestSagas;
